import React, { Component } from "react";
import { connect } from "react-redux";
import { schoolSelectors } from "../../store/school";
import { Block, Divider, Tabs, Backdrop, Overlay } from "reakit";
import { withRouter } from "react-router";
import { Box, Button, Card, Flex, Heading, Image, Text } from "rebass";
import { Content, TabHeader } from "../../components/Base";
import { SaveButton } from "../../components/Base/Buttons";

import "../../resources/css/fab.css";
//import MdCreate from 'react-ionicons/lib/MdCreate'
import MdTrash from "react-ionicons/lib/MdTrash";
import ConfirmDelete from "../../components/Modals/ConfirmDelete";
import IosArrowBack from "react-ionicons/lib/IosArrowBack";

import Customize from "../NewPost/Customize";
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import GradeSelect from "../../components/Forms/Grade";
import { Switch } from "@smooth-ui/core-sc";
import { ContentText, PageTitle } from "./styles";
import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import {
  EditorState,
  convertFromRaw,
  RichUtils,
  convertToRaw,
  CompositeDecorator,
} from "draft-js";
import Editor from "draft-js-plugins-editor";
import createLinkifyPlugin from "draft-js-linkify-plugin";
import MultiDecorator from "draft-js-plugins-editor/lib/Editor/MultiDecorator";
import "draft-js-linkify-plugin/lib/plugin.css";
import MdFolderOpen from "react-ionicons/lib/MdFolderOpen";
import MdCloseCircle from "react-ionicons/lib/MdCloseCircle";
import MdAddCircle from "react-ionicons/lib/MdAddCircle";
import { PinIcon, UnpinIcon } from "../../components/Base/Icons";

import UserList from "../../components/UserList";

const linkifyPlugin = createLinkifyPlugin({ target: "_blank" });
const plugins = [linkifyPlugin];

const StyleButton = styled(Button)`
  background-color: white;
  color: black;
  font-weight: 900;
  transition: 0.2s ease;
  padding: 8px;
  margin-right: 4px;
  font-size: 16px;
  cursor: pointer;
  opacity: 0.2;
  ${({ active }) =>
    active &&
    `
		opacity: 1;
	`}
  &:last-child {
    margin-right: 0;
    padding-right: 0;
  }
`;

const textProps = {
  ml: 3,
};

const AttachmentWrapper = styled.a`
  position: relative;
  border-radius: 4px;
  border: 1px solid black;
  flex-shrink: 0;
  padding: 10px;
  margin: 14px 14px 0 0;
  color: inherit;
  display: flex;
  align-items: center;
  max-width: 100%;
  box-sizing: border-box;
`;

const AttachmentWrapperEdit = styled(Flex)`
  position: relative;
  border-radius: 4px;
  border: 1px solid black;
  flex-shrink: 0;
  padding: 10px;
  margin: 14px 14px 0 0;
  max-width: 100%;
  box-sizing: border-box;
`;

const RemoveButton = styled(MdCloseCircle)`
  cursor: pointer;
  position: absolute;
  top: -12px;
  right: -10px;
`;

const UploadButton = styled.label`
  cursor: pointer;
  & > input[type="file"] {
    display: none;
  }
`;

const ProgressBar = styled.div`
  margin: 16px 0;
  width: 100%;
  height: 14px;
  background-color: #e9ecef;
  border-radius: 20px;
`;

const ProgressBarAnimation = keyframes`
	0% { background-position: 1rem 0; }
	100% { background-position: 0 0; }
`;

const LineBar = styled.div`
  ${({ value }) =>
    value &&
    `
		width: ${value}%;
	`}
  height: 100%;
  animation: ${ProgressBarAnimation} 1s linear infinite;
  background-image: linear-gradient(
    45deg,
    hsla(0, 0%, 100%, 0.15) 25%,
    transparent 0,
    transparent 50%,
    hsla(0, 0%, 100%, 0.15) 0,
    hsla(0, 0%, 100%, 0.15) 75%,
    transparent 0,
    transparent
  );
  background-size: 1rem 1rem;
  background-color: #007bff;
  transition: 0.3s ease;
  border-radius: 14px;
`;

const NewOverlay = styled(Overlay)`
  padding: 0 !important;
  width: 88vw;
  max-height: 96vh;
  overflow: auto;
`;

const MobileOverlay = styled(Overlay)`
  padding: 0 !important;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ActionWrapper = styled(Box)`
  flex-shrink: 0;
`;

const ActionButton = styled(Button)`
  width: 30px;
  height: 30px;
  background-color: #f7c649;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.14), 0 2px 6px rgba(0, 0, 0, 0.28);
  border-radius: 50%;
  padding: 0;
  cursor: pointer;
  &:first-child {
    margin-right: 8px;
  }
  ${({ red }) =>
    red &&
    `
		background-color: #F95050;
	`}
  ${({ pin }) =>
    pin &&
    `
		background-color: #ee8338;
	`}
`;

const PinnedIcon = styled(PinIcon)`
  width: 12px;
  position: absolute;
  left: -20px;
  top: 3px;

  @media (max-width: 639px) {
    position: unset;
  }
`;

const UnpinnedIcon = styled(UnpinIcon)`
  width: 9px;
  position: relative;

  @media (max-width: 639px) {
    position: unset;
  }
`;

// Post/Announcement Details page, see bottom for renderMessage which shows the post

class PostDetails extends Component {
  state = {
    owner: { first_name: "", last_name: "", id: 1 },
    edit: false,
    editAudience: [[], [], []],
    inviteFaculty: [],
    editDetails: null,
    confirmDelete: false,
    editorState: EditorState.createEmpty(),
    currentAttachments: [],
    fileAttachment: null,
    deletedAttachment: [],
    showBar: false,
    barValue: 0,
    width: 0,
    height: 0,
    selectFaculty: false,
    faculty: [],
  };

  componentDidMount() {
    //this.fetchOwnerInfo()
    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  fetchOwnerInfo = async () => {
    const { post, firebase } = this.props;
    // console.log(post)
    try {
      if (post.creator_is_student === true) {
        let studentRef = await firebase.student(post.creator_uid).get();

        const data = { id: studentRef.id, ...studentRef.data() };
        this.setState({ owner: data });
      } else {
        let studentRef = await firebase.faculty(post.creator_uid).get();

        const data = { id: studentRef.id, ...studentRef.data() };
        // console.log('data', data)
        this.setState({ owner: data });
      }
    } catch (e) {
      console.log(e);
    }
  };

  handleApprovePost = async () => {
    const { post, isFaculty, history, profile } = this.props;
    if (isFaculty) {
      try {
        let postRef = this.props.firebase.post(post.id);
        postRef.update({
          status: 1,
          status_updated_by: profile.id,
        });
        history.push("/app/home");
      } catch (e) {
        console.log(e);
      }
    }
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      nextProps.post !== this.props.post &&
      this.state.confirmDelete !== true
    ) {
      //this.fetchOwnerInfo()
    }
  }

  handleDecline = async () => {
    const { post, isFaculty, history, profile } = this.props;
    if (isFaculty) {
      try {
        let postRef = this.props.firebase.post(post.id);
        postRef.update({
          status: 2,
          status_updated_by: profile.id,
        });
        history.push("/app/home");
      } catch (e) {
        console.log(e);
      }
    }
  };

  getAudienceString = (post, school) => {
    let result = [];
    if (post.gender_tag.length > 0) {
      let genderResult = post.gender_tag
        .map((item) => (item === "M" ? "Male" : "Female"))
        .join(", ");
      result.push(genderResult);
    }
    if (post.grade_tag.length > 0) {
      let gradeResult = post.grade_tag.map((item) =>
        item === "3" ? item + "rd Form" : item + "th Form"
      );
      result.push(gradeResult);
    }

    if (post.dorm_tag.length > 0 && school.dormMap) {
      let dormResult = post.dorm_tag
        .map((item) =>
          school.dormMap[item] !== undefined ? school.dormMap[item].name : ""
        )
        .join(", ");
      result.push(dormResult);
    }
    return result;
  };

  // edit functions

  handleAudience = (data) => {
    this.setState({ editAudience: data });
  };

  handleInputChange = (e) => {
    const { editDetails } = this.state;
    this.setState({
      editDetails: { ...editDetails, [e.target.name]: e.target.value },
    });
  };

  handlePinnedImportant = (name, value) => {
    const { editDetails } = this.state;
    this.setState({ editDetails: { ...editDetails, [name]: value } });
  };

  handleAudienceSelect = (name, index) => {
    let audience = this.state.editAudience;
    let contains = false;
    for (var i = audience[index].length - 1; i >= 0; i--) {
      if (audience[index][i] === name) {
        audience[index].splice(i, 1);
        contains = true;
        this.setState({ editAudience: audience });
        // break;       //<-- Uncomment  if only the first term has to be removed
      }
    }

    if (!contains) {
      audience[index].push(name);
      this.setState({ editAudience: audience });
    }
  };

  handleFacultySelect = (details) => {
    let selected = this.state.inviteFaculty;
    let contains = false;
    for (var i = selected.length - 1; i >= 0; i--) {
      if (selected[i] === details.id) {
        selected.splice(i, 1);
        contains = true;
        this.setState({ inviteFaculty: selected });
        // break;       //<-- Uncomment  if only the first term has to be removed
      }
    }

    if (!contains) {
      selected.push(details.id);
      this.setState({ inviteFaculty: selected });
    }
  };

  handleSwitch = (e) => {
    if (e.target.checked) {
      this.setState({
        editDetails: {
          ...this.state.editDetails,
          [e.target.name]: e.target.checked,
        },
      });
    } else {
      this.setState({
        editDetails: { ...this.state.editDetails, [e.target.name]: false },
      });
    }
  };

  handleSubmit = async () => {
    const { profile, isFaculty, post, firebase } = this.props;
    const {
      editDetails,
      editAudience,
      editorState,
      deletedAttachment,
      fileAttachment,
      currentAttachments,
    } = this.state;

    const storageRef = firebase.storage.ref();
    for (const item of deletedAttachment) {
      await storageRef.child(item.fullName).delete();
    }

    let newAttachments = [];
    if (fileAttachment != null) {
      this.setState({ showBar: true }, () => this.setState({ barValue: 10 }));
      let progressInc = Number(90 / fileAttachment.length).toFixed(2);
      for (const file of fileAttachment) {
        let name = new Date().getTime() + "-" + file.name;
        let task = await storageRef
          .child(name)
          .put(file, { contentType: file.type });
        let downloadURL = await task.ref.getDownloadURL();
        this.setState((state) => ({
          barValue: Number(state.barValue) + Number(progressInc),
        }));
        newAttachments.push({
          url: downloadURL,
          name: file.name,
          type: file.type,
          size: this.bytesToSize(file.size),
          fullName: name,
        });
      }
    }

    let newDetails = editDetails;
    newDetails.gender_tag = editAudience[0];
    newDetails.grade_tag = editAudience[1];
    newDetails.dorm_tag = editAudience[2];
    newDetails.richMessage = convertToRaw(editorState.getCurrentContent());
    newDetails["attachments"] = [...currentAttachments, ...newAttachments];

    if (post.creator_uid === profile.id) {
      let postRef = this.props.firebase.post(post.id);
      if (isFaculty) {
        postRef
          .update({
            ...newDetails,
            post_time: Math.floor(Date.now() / 1000),
          })
          .then(() => {
            this.setState({
              edit: false,
              editDetails: null,
              editorState: EditorState.createEmpty(),
              currentAttachments: [],
              fileAttachment: null,
              deletedAttachment: [],
              showBar: false,
              barValue: 0,
            });
          });
      } else {
        postRef
          .update({
            ...newDetails,
            status: 0,
            post_time: Math.floor(Date.now() / 1000),
          })
          .then(() => {
            this.setState({
              edit: false,
              editDetails: null,
              editorState: EditorState.createEmpty(),
              currentAttachments: [],
              fileAttachment: null,
              deletedAttachment: [],
              showBar: false,
              barValue: 0,
            });
          });
      }
      // this.setState({
      // 	edit: false,
      // 	editDetails: null,
      // 	editorState: EditorState.createEmpty(),
      // 	currentAttachments: [],
      // 	fileAttachment: null,
      // 	deletedAttachment: []
      // });
    } else if (isFaculty && post.creator_is_student) {
      if (newDetails !== post) {
        let postRef = this.props.firebase.post(post.id);
        await postRef.update({
          ...newDetails,
          post_time: Math.floor(Date.now() / 1000),
        });
      }
    }
    this.toggleEditMode();
  };

  handleDelete = async () => {
    const { profile, firebase, post, history } = this.props;
    const storageRef = firebase.storage.ref();
    if (profile.id === post.creator_uid) {
      for (const item of post.attachments) {
        await storageRef.child(item.fullName).delete();
      }

      firebase
        .post(post.id)
        .delete()
        .then(() => {
          //history.replace('/app/home');
          //history.push('/app/posts')

          if (history.location.pathname === "/app/posts") {
            history.replace("/app/home");
            history.push("/app/posts");
          }

          this.setState({ confirmDelete: false });
        })
        .catch((error) => console.log("Error removing document: ", error));
    }
  };

  handleUnpin = async () => {
    const { isFaculty, profile, post } = this.props;
    if (post.creator_uid === profile.id) {
      let postRef = this.props.firebase.post(post.id);
      if (isFaculty) {
        postRef.update({
          is_pinned: false,
        });
      }
    }
  };

  toggleFacultySelect = () => {
    this.setState({ selectFaculty: true });
  };

  toggleEditMode = () => {
    const { post } = this.props;
    const { edit } = this.state;
    if (edit === true) {
      this.setState({ edit: false });
    } else {
      const audience = [post.gender_tag, post.grade_tag, post.dorm_tag];
      this.setState({
        editDetails: post,
        editAudience: audience,
        edit: true,
        editorState: EditorState.createWithContent(
          convertFromRaw(post.richMessage)
        ),
        currentAttachments: [...post.attachments],
        fileAttachment: null,
        deletedAttachment: [],
        showBar: false,
        barValue: 0,
      });
    }
  };

  handleEditorChange = (editorState) => {
    this.setState({ editorState });
  };

  handleKeyCommand = (command) => {
    const newState = RichUtils.handleKeyCommand(
      this.state.editorState,
      command
    );
    if (newState) {
      this.handleEditorChange(newState);
      return "handled";
    }
    return "not-handled";
  };

  editorRef = React.createRef();

  editorFocus = () => {
    this.editorRef.current.focus();
  };

  handleUnderlineClick = (e) => {
    e.preventDefault();
    this.handleEditorChange(
      RichUtils.toggleInlineStyle(this.state.editorState, "UNDERLINE")
    );
  };

  handleBoldClick = (e) => {
    e.preventDefault();
    this.handleEditorChange(
      RichUtils.toggleInlineStyle(this.state.editorState, "BOLD")
    );
  };

  handleItalicClick = (e) => {
    e.preventDefault();
    this.handleEditorChange(
      RichUtils.toggleInlineStyle(this.state.editorState, "ITALIC")
    );
  };

  StyleButtons = (props) => {
    const currentStyle = props.editorState.getCurrentInlineStyle();
    const characters = this.state.editorState.getCurrentContent().getPlainText()
      .length;

    return (
      <Flex justifyContent={"space-between"} alignItems={"center"}>
        <Flex alignItems={"center"}>
          <UploadButton htmlFor="postFile">
            <MdAddCircle />
            <input
              type="file"
              id="postFile"
              onChange={this.handleFileChange}
              multiple
            />
          </UploadButton>
          <Text
            ml={2}
            mb={"2px"}
            fontSize={"14px"}
            color={characters > 400 ? "red" : "#969a9b"}
            fontWeight={characters > 400 ? "bold" : "normal"}
          >
            {characters} / 400 characters
          </Text>
        </Flex>
        <Box>
          <StyleButton
            onMouseDown={this.handleBoldClick}
            active={currentStyle.has("BOLD")}
          >
            B
          </StyleButton>
          <StyleButton
            onMouseDown={this.handleItalicClick}
            active={currentStyle.has("ITALIC")}
          >
            I
          </StyleButton>
          <StyleButton
            onMouseDown={this.handleUnderlineClick}
            active={currentStyle.has("UNDERLINE")}
          >
            U
          </StyleButton>
        </Box>
      </Flex>
    );
  };

  getPluginDecoratorArray = () => {
    let decorators = [];
    let plugin;
    for (plugin of plugins) {
      if (plugin.decorators !== null && plugin.decorators !== undefined) {
        decorators = decorators.concat(plugin.decorators);
      }
    }
    return decorators;
  };

  grabAllPluginDecorators = () => {
    return new MultiDecorator([
      new CompositeDecorator(this.getPluginDecoratorArray()),
    ]);
  };

  handleFileChange = (e) => {
    const { fileAttachment } = this.state;
    e.preventDefault();
    const files = Array.from(e.target.files);

    if (fileAttachment == null) {
      this.setState({
        fileAttachment: files,
      });
    } else {
      this.setState((state) => ({
        fileAttachment: [...state.fileAttachment, ...files],
      }));
    }
  };

  handleDeleteFile = (index) => {
    this.setState((state) => ({
      fileAttachment: state.fileAttachment.filter((_, i) => i !== index),
    }));
  };

  bytesToSize = (bytes, decimals = 1) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1000;
    // const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  handleDeleteOriginalFile = (file, index) => {
    const { post } = this.props;
    console.log("file", file);
    console.log("post", post);
    this.setState((state) => ({
      deletedAttachment: [...state.deletedAttachment, file],
      currentAttachments: state.currentAttachments.filter(
        (_, i) => i !== index
      ),
    }));
  };

  render() {
    const {
      owner,
      edit,
      editDetails,
      confirmDelete,
      editAudience,
      editorState,
      fileAttachment,
      currentAttachments,
      showBar,
      barValue,
      width,
      selectFaculty,
    } = this.state;
    const {
      loading,
      post,
      isFaculty,
      profile,
      schoolInfo,
      formatName,
      formatDate,
      hideName,
      pinnedPost,
      faculty,
    } = this.props;

    let audience = "Audience: All Students";
    let result = [];

    if (result.length > 0) {
      audience = `Audience: ${result.join(", ")}`;
    }

    if (owner.id === "undefined" && confirmDelete !== true) {
      //this.fetchOwnerInfo()
    }

    let showFab = false;
    //post is editable by only creator
    if (profile.id === post.creator_uid) {
      showFab = true;
    }

    const messageLength = editorState.getCurrentContent().getPlainText().length;

    let disableSubmit = true;
    if (messageLength > 0 && messageLength <= 400) {
      disableSubmit = false;
    }

    let customizeReady = false;
    if (messageLength > 0 && messageLength <= 400) {
      customizeReady = true;
    }

    const messageContent = EditorState.createWithContent(
      convertFromRaw(post.richMessage),
      this.grabAllPluginDecorators()
    );

    return (
      <Box p={[0]}>
        <ContentText>
          {pinnedPost && <PinnedIcon />}
          {loading ? (
            <Text fontWeight={600}>Loading...</Text>
          ) : (
            <Editor
              readOnly
              plugins={plugins}
              editorState={messageContent}
              onChange={this.handleEditorChange}
            />
          )}
          <Flex flexWrap={"wrap"}>
            {post.attachments != null &&
              post.attachments.map((file, index) => (
                <AttachmentWrapper href={file.url} target="_blank" key={index}>
                  <MdFolderOpen
                    style={{ marginRight: "10px", flexShrink: 0 }}
                    fontSize="28px"
                  />
                  <Box>
                    <Heading fontSize={"16px"}>
                      {file.name.length > 30
                        ? file.name.slice(0, 26) + "..."
                        : file.name}{" "}
                      ({file.size})
                    </Heading>
                    <Text fontSize={"14px"}>{file.type}</Text>
                  </Box>
                </AttachmentWrapper>
              ))}
          </Flex>
          <Flex pt={2} justifyContent={"space-between"} alignItems={"center"}>
            <Box mr={1} mt={2}>
              {!hideName && (
                <Text p={0} pb={"6px"} fontSize={"12px"} fontWeight={600}>
                  {formatName}
                </Text>
              )}
              <Text fontSize={"12px"} fontWeight={600} color={"metaText"}>
                {formatDate}
              </Text>
            </Box>
            {/* { showFab && !edit && post.status !== 0 && ( */}
            {showFab && !edit && (
              <ActionWrapper>
                {/* <ActionButton onClick={this.toggleEditMode}><MdCreate fontSize="14px" color={'white'} /></ActionButton> */}
                {pinnedPost && (
                  <ActionButton pin onClick={this.handleUnpin}>
                    <Flex justifyContent="center">
                      <UnpinnedIcon />
                    </Flex>
                  </ActionButton>
                )}
                <ActionButton
                  red
                  onClick={() => this.setState({ confirmDelete: true })}
                >
                  <MdTrash fontSize="14px" color={"white"} />
                </ActionButton>
              </ActionWrapper>
            )}
          </Flex>
          <ConfirmDelete
            visible={confirmDelete}
            toggle={() => this.setState({ confirmDelete: false })}
            handleConfirm={this.handleDelete}
          />
        </ContentText>

        {profile && profile.is_admin && isFaculty && post.status === 0 && (
          <Box>
            <Flex mt={3} justifyContent={"center"}>
              <Button
                variant={"main"}
                bg={"green"}
                mr={[2, 4]}
                onClick={this.handleApprovePost}
              >
                Approve
              </Button>
              <Button variant={"main"} bg={"red"} onClick={this.handleDecline}>
                Decline
              </Button>
            </Flex>
          </Box>
        )}

        {edit && (
          <Overlay.Container>
            {(overlay) => (
              <Block>
                {width > 768 ? (
                  <>
                    <Backdrop
                      fade
                      use={Overlay.Hide}
                      {...overlay}
                      visible={edit}
                      onClick={this.toggleEditMode}
                    />
                    <NewOverlay
                      fade
                      slide
                      {...overlay}
                      visible={edit}
                      style={{ padding: 0 }}
                    >
                      {!selectFaculty && (
                        <Content>
                          <Flex flexWrap={"wrap"} flexDirection={"row"} p={4}>
                            <Box
                              width={[1, edit ? 1 / 2 : 1]}
                              p={[3, 0]}
                              pr={[3, "48px"]}
                            >
                              <Box mb={4}>
                                <SaveButton
                                  disabled={disableSubmit}
                                  onClick={
                                    isFaculty
                                      ? this.handleSubmit
                                      : this.toggleFacultySelect
                                  }
                                  bg={disableSubmit ? "gray" : "purple"}
                                  mr={2}
                                >
                                  {isFaculty ? "Save" : "Next"}
                                </SaveButton>
                                <SaveButton
                                  bg={"metaText"}
                                  onClick={() => this.setState({ edit: false })}
                                >
                                  Discard
                                </SaveButton>
                              </Box>

                              <Box>
                                <this.StyleButtons editorState={editorState} />
                                <Box
                                  onClick={this.editorFocus}
                                  className="post-editor"
                                >
                                  <Editor
                                    editorState={editorState}
                                    onChange={this.handleEditorChange}
                                    handleKeyCommand={this.handleKeyCommand}
                                    placeholder="Type your announcement"
                                    ref={this.editorRef}
                                    plugins={plugins}
                                  />
                                </Box>
                                {showBar && (
                                  <ProgressBar>
                                    <LineBar value={barValue} />
                                  </ProgressBar>
                                )}
                                <Flex flexWrap={"wrap"} mt={2}>
                                  {currentAttachments != null &&
                                    currentAttachments.map((file, index) => (
                                      <AttachmentWrapperEdit
                                        key={index}
                                        alignItems={"center"}
                                      >
                                        <MdFolderOpen
                                          style={{
                                            marginRight: "10px",
                                            flexShrink: 0,
                                          }}
                                          fontSize="28px"
                                        />
                                        <Box>
                                          <Heading fontSize={"16px"}>
                                            {file.name.length > 30
                                              ? file.name.slice(0, 26) + "..."
                                              : file.name}{" "}
                                            ({file.size})
                                          </Heading>
                                          <Text fontSize={"14px"}>
                                            {file.type}
                                          </Text>
                                        </Box>
                                        <RemoveButton
                                          onClick={() => {
                                            this.handleDeleteOriginalFile(
                                              file,
                                              index
                                            );
                                          }}
                                        />
                                      </AttachmentWrapperEdit>
                                    ))}
                                  {fileAttachment != null &&
                                    fileAttachment.map((file, index) => (
                                      <AttachmentWrapperEdit
                                        key={index}
                                        alignItems={"center"}
                                      >
                                        <MdFolderOpen
                                          style={{
                                            marginRight: "10px",
                                            flexShrink: 0,
                                          }}
                                          fontSize="28px"
                                        />
                                        <Box>
                                          <Heading fontSize={"16px"}>
                                            {file.name.length > 30
                                              ? file.name.slice(0, 26) + "..."
                                              : file.name}{" "}
                                            ({this.bytesToSize(file.size)})
                                          </Heading>
                                          <Text fontSize={"14px"}>
                                            {file.type}
                                          </Text>
                                        </Box>
                                        <RemoveButton
                                          onClick={() => {
                                            this.handleDeleteFile(index);
                                          }}
                                        />
                                      </AttachmentWrapperEdit>
                                    ))}
                                </Flex>
                              </Box>
                            </Box>

                            <Box width={[1, 1 / 2]} pt={[0, "36px"]}>
                              <Flex flexDirection={"row"}>
                                <Box width={1 / 2} p={[3, 0]} pr={[3, "24px"]}>
                                  <PageTitle mb={"20px"}>Audience</PageTitle>
                                  <Tabs.Container>
                                    {(tabs) => (
                                      <Block>
                                        <Tabs>
                                          <Tabs.Tab tab="dorm" {...tabs}>
                                            <TabHeader title={"Dorm"} />
                                          </Tabs.Tab>
                                          <Tabs.Tab tab="gender" {...tabs}>
                                            <TabHeader title={"Gender"} />
                                          </Tabs.Tab>
                                          <Tabs.Tab tab="grade" {...tabs}>
                                            <TabHeader title={"Grade"} />
                                          </Tabs.Tab>
                                        </Tabs>
                                        <Tabs.Panel tab="gender" {...tabs}>
                                          <Card mt={"28px"} boxShadow={"inset"}>
                                            <Divider />
                                            <Flex
                                              onClick={() =>
                                                this.handleAudienceSelect(
                                                  "F",
                                                  0
                                                )
                                              }
                                            >
                                              <Box>
                                                <Text
                                                  {...textProps}
                                                  name="male"
                                                >
                                                  Female
                                                </Text>
                                              </Box>
                                              <Box ml={"auto"} />
                                              <Box pr={2}>
                                                {editAudience[0].includes(
                                                  "F"
                                                ) && <Image src={check} />}
                                              </Box>
                                            </Flex>
                                            <Divider />
                                            <Flex
                                              onClick={() =>
                                                this.handleAudienceSelect(
                                                  "M",
                                                  0
                                                )
                                              }
                                            >
                                              <Box>
                                                <Text {...textProps} name="M>">
                                                  Male
                                                </Text>
                                              </Box>
                                              <Box ml={"auto"} />
                                              <Box pr={2}>
                                                {editAudience[0].includes(
                                                  "M"
                                                ) && <Image src={check} />}
                                              </Box>
                                            </Flex>
                                            <Divider />
                                          </Card>
                                        </Tabs.Panel>
                                        <Tabs.Panel tab="grade" {...tabs}>
                                          <Card mt={"28px"} boxShadow={"inset"}>
                                            <GradeSelect
                                              handleSelect={
                                                this.handleAudienceSelect
                                              }
                                              audience={audience}
                                            />
                                          </Card>
                                        </Tabs.Panel>
                                        <Tabs.Panel tab="dorm" {...tabs}>
                                          <Card mt={"28px"} boxShadow={"inset"}>
                                            <Divider />
                                            {schoolInfo.dorms.map((dorm) => (
                                              <Box width={1}>
                                                <Flex
                                                  key={dorm.id}
                                                  onClick={() =>
                                                    this.handleAudienceSelect(
                                                      dorm.id,
                                                      2
                                                    )
                                                  }
                                                >
                                                  <Box>
                                                    <Text {...textProps}>
                                                      {dorm.name}
                                                    </Text>
                                                  </Box>
                                                  <Box ml={"auto"} />
                                                  <Box pr={2}>
                                                    {editAudience[2].includes(
                                                      dorm.id
                                                    ) && <Image src={check} />}
                                                  </Box>
                                                </Flex>
                                                <Divider />
                                              </Box>
                                            ))}
                                          </Card>
                                        </Tabs.Panel>
                                      </Block>
                                    )}
                                  </Tabs.Container>
                                </Box>

                                <Box width={1 / 2} p={[3, 0]} pl={[3, "24px"]}>
                                  {isFaculty && (
                                    <Card mt={2}>
                                      <Flex
                                        mt={4}
                                        justifyContent={"space-between"}
                                        mb={1}
                                      >
                                        <Box>
                                          <Heading>Pin</Heading>
                                        </Box>
                                        <Box>
                                          <Switch
                                            name={"is_pinned"}
                                            checked={editDetails.is_pinned}
                                            onChange={this.handleSwitch}
                                          />
                                        </Box>
                                      </Flex>
                                      <Text color={"metaText"}>
                                        By switching on the switch, your post
                                        will be pinned at the top of the post
                                        feed.
                                      </Text>
                                      <Flex
                                        mt={4}
                                        justifyContent={"space-between"}
                                        mb={1}
                                      >
                                        <Box>
                                          <Heading>Important</Heading>
                                        </Box>
                                        <Box>
                                          <Switch
                                            name="is_important"
                                            checked={editDetails.is_important}
                                            onChange={this.handleSwitch}
                                          />
                                        </Box>
                                      </Flex>
                                      <Text color={"metaText"}>
                                        By switching on the switch, all students
                                        will be notified of this post.
                                      </Text>
                                    </Card>
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                          </Flex>
                        </Content>
                      )}

                      {selectFaculty && (
                        <Content p={3}>
                          <Box mb={4}>
                            <SaveButton
                              disabled={this.state.inviteFaculty.length === 0}
                              onClick={this.handleSubmit}
                              m={1}
                              bg={
                                this.state.inviteFaculty.length === 0
                                  ? "gray"
                                  : "purple"
                              }
                            >
                              Save
                            </SaveButton>
                            <Link to={"/app/home"}>
                              <SaveButton m={1} bg={"metaText"}>
                                Discard
                              </SaveButton>
                            </Link>
                          </Box>
                          <Heading>Invite at least one faculty member</Heading>
                          <UserList
                            students={faculty}
                            selected={this.state.inviteFaculty}
                            handleUserClick={this.handleFacultySelect}
                          />
                        </Content>
                      )}
                    </NewOverlay>
                  </>
                ) : (
                  <MobileOverlay
                    fade
                    slide
                    {...overlay}
                    visible={edit}
                    style={{ padding: 0 }}
                  >
                    <Content>
                      <Box height={"30px"} width={"30px"}>
                        <IosArrowBack
                          onClick={this.toggleEditMode}
                          style={{ paddingLeft: "16px", paddingTop: "16px" }}
                          color={"black"}
                          fontSize="30px"
                        />
                      </Box>
                      <Box p={"24px"}>
                        <Text color={"meta"} mb={3} fontWeight={600}>
                          {audience && audience}
                        </Text>
                        <Customize
                          handleSubmit={this.handleSubmit}
                          school={schoolInfo}
                          handlePinned={this.handlePinnedImportant}
                          ready={customizeReady}
                          dorms={schoolInfo.dorms}
                          locations={schoolInfo.locations}
                          faculty={faculty}
                          handleAudience={this.handleAudience}
                          editPost
                          isFaculty={isFaculty}
                          isPinned={editDetails.is_pinned}
                          isImportant={editDetails.is_important}
                          editAudience={editAudience}
                        />
                        <Box mt={4}>
                          <this.StyleButtons editorState={editorState} />
                          <Box
                            onClick={this.editorFocus}
                            className="post-editor"
                          >
                            <Editor
                              editorState={editorState}
                              onChange={this.handleEditorChange}
                              handleKeyCommand={this.handleKeyCommand}
                              placeholder="Type your announcement"
                              ref={this.editorRef}
                              plugins={plugins}
                            />
                          </Box>
                          {showBar && (
                            <ProgressBar>
                              <LineBar value={barValue} />
                            </ProgressBar>
                          )}
                          <Flex flexWrap={"wrap"} mt={2}>
                            {currentAttachments != null &&
                              currentAttachments.map((file, index) => (
                                <AttachmentWrapperEdit
                                  key={index}
                                  alignItems={"center"}
                                >
                                  <MdFolderOpen
                                    style={{
                                      marginRight: "10px",
                                      flexShrink: 0,
                                    }}
                                    fontSize="28px"
                                  />
                                  <Box>
                                    <Heading fontSize={"16px"}>
                                      {file.name.length > 30
                                        ? file.name.slice(0, 26) + "..."
                                        : file.name}{" "}
                                      ({file.size})
                                    </Heading>
                                    <Text fontSize={"14px"}>{file.type}</Text>
                                  </Box>
                                  <RemoveButton
                                    onClick={() => {
                                      this.handleDeleteOriginalFile(
                                        file,
                                        index
                                      );
                                    }}
                                  />
                                </AttachmentWrapperEdit>
                              ))}
                            {fileAttachment != null &&
                              fileAttachment.map((file, index) => (
                                <AttachmentWrapperEdit
                                  key={index}
                                  alignItems={"center"}
                                >
                                  <MdFolderOpen
                                    style={{
                                      marginRight: "10px",
                                      flexShrink: 0,
                                    }}
                                    fontSize="28px"
                                  />
                                  <Box>
                                    <Heading fontSize={"16px"}>
                                      {file.name.length > 30
                                        ? file.name.slice(0, 26) + "..."
                                        : file.name}{" "}
                                      ({this.bytesToSize(file.size)})
                                    </Heading>
                                    <Text fontSize={"14px"}>{file.type}</Text>
                                  </Box>
                                  <RemoveButton
                                    onClick={() => {
                                      this.handleDeleteFile(index);
                                    }}
                                  />
                                </AttachmentWrapperEdit>
                              ))}
                          </Flex>
                        </Box>
                      </Box>
                    </Content>
                  </MobileOverlay>
                )}
              </Block>
            )}
          </Overlay.Container>
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
});

export default withRouter(connect(mapStateToProps)(PostDetails));
